// extracted by mini-css-extract-plugin
export var defaultWrapper = "_kr-3";
export var downloadButton = "_kr-4";
export var fileContainer = "_kr-9 _kr-7";
export var fileContainerBase = "_kr-7";
export var fileContainerFixedHeight = "_kr-8 _kr-7";
export var fileInfo = "_kr-5";
export var fileInfoWidthRestricted = "_kr-6";
export var fileType = "_kr-1";
export var fileTypeName = "_kr-2";
export var image = "_kr-0";
export var link = "_kr-b";
export var overflowEllipsis = "_kr-a";